<template>
  <div class="cover-container">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in imglist"
          :key="index"
        >
          <img :src="item"/>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/css/swiper.min.css';

  export default {
    data() {
      return {
        imglist: this._websiteInfo.backgroundImages
      }
    },
    mounted() {
      if (Array.isArray(this.imglist) && this.imglist.length > 1) {
        this.initSwiper();
      }
    },
    methods: {
      initSwiper() {
        new Swiper('.swiper-container', {
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
          },
          loop: true,
          autoplay: true
        });
      },
    }
  }
</script>

<style scoped lang="scss">
  .cover-container {

    .swiper-container {
      .swiper-slide {
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
